<div class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <div class="ui-g-12">
        <div class="section-header">
          {{ 'regep.models-feed-in-compensation.title' | translate }}
          <i
            class="pi pi-info-circle hint-icon"
            [pTooltip]="'tooltips.technical-data.regep.models-feed-in-compensation' | translate"
            tooltipPosition="left"></i>
        </div>
      </div>
      <div class="section-buttons" *ngIf="sectionButtonsVisible() | async">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div class="form-background margin-align" [ngClass]="{ 'disable-section': getSectionLocked() && applicationId }">
    <div class="top-bottom-margin">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 models-container">
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          {{ 'regep.models-feed-in-compensation.compensation-model' | translate }}
        </div>

        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <div class="ui-g-6 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <p-radioButton
              name="compensation_model"
              [value]="COMPENSATION_MODELS.Monthly"
              [(ngModel)]="regulatoryData.compensation_model"
              #compensation_model="ngModel"
              required
              [disabled]="isSectionDisabled"></p-radioButton>
            <label class="field-label">
              {{ 'regep.models-feed-in-compensation.compensation-model-monthly' | translate }}
            </label>
          </div>
          <div class="ui-g-6 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <p-radioButton
              name="compensation_model"
              [value]="COMPENSATION_MODELS.Yearly"
              [(ngModel)]="regulatoryData.compensation_model"
              #compensation_model="ngModel"
              required
              [disabled]="isSectionDisabled"></p-radioButton>
            <label class="field-label">
              {{ 'regep.models-feed-in-compensation.compensation-model-yearly' | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
